import script from "./WCPaymentOptionBadgesModernCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./WCPaymentOptionBadgesModernCard.vue?vue&type=script&setup=true&lang=ts"

import "./WCPaymentOptionBadgesModernCard.vue?vue&type=style&index=0&id=baf1de0a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-baf1de0a"]])

export default __exports__